import { createCsvValidator } from '~/components/general/createCsvValidator';

export const groupsCsvValidator = createCsvValidator({
    maxFileSizeBytes: 100 * 1024 ** 2,
    requiredHeadings: ['group_id'],
    optionalHeadings: ['group_name', 'group_time_zone'],
});

export const validateGroupsCsv = groupsCsvValidator.validate;
